// PLAN-cockpit-v2 Phase 0-D: Detail panel の表示状態 (Lens 別 default + 手動 toggle)
import { useCallback, useEffect, useState } from 'react'
import type { LensId } from '../router'

const STORAGE_KEY = 'cockpit_v2.detail_visible'

const LENS_DEFAULT: Record<LensId, boolean> = {
  home: false,
  explore: true,
  reflect: false,
  // curate 廃止
  finance: false,
  health: false,
  mind: false,
  collaborate: false,
  graph: true,
  judgment: false,  // PLAN-judgment-cockpit (2026-05-15)
}

interface PerLens {
  [k: string]: boolean
}

function readStored(): PerLens {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY)
    if (!raw) return {}
    return JSON.parse(raw) as PerLens
  } catch {
    return {}
  }
}

function writeStored(map: PerLens) {
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(map))
  } catch {
    /* ignore */
  }
}

export function useDetailVisibility(lens: LensId): { visible: boolean; toggle: () => void; set: (v: boolean) => void } {
  const [map, setMap] = useState<PerLens>(readStored)

  const visible = map[lens] ?? LENS_DEFAULT[lens]

  const set = useCallback(
    (v: boolean) => {
      setMap((prev) => {
        const next = { ...prev, [lens]: v }
        writeStored(next)
        return next
      })
    },
    [lens]
  )

  const toggle = useCallback(() => set(!visible), [set, visible])

  // lens が変わったら map を同期 (UI 上は再 render)
  useEffect(() => {
    /* no-op、visible は map[lens] で導出 */
  }, [lens])

  return { visible, toggle, set }
}
